import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
};

const Button = props => {
  const {test, ...restOfProps} = {...props};
  return (
    <button
      {...restOfProps}
      data-test={test}
      className={`ds-btn ` + restOfProps.className}
      onClick={restOfProps.onClick}>
      {restOfProps.label}
    </button>
  );
};

Button.propTypes = propTypes;

export default Button;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/Button.js